import { defaultProps } from 'recompose';

import { svg, defaultWidgetConfig } from 'constants';

import CommonButton from './CommonButton';

export default defaultProps({
  tooltipText: 'Calendar',
  icon: svg.calendar,
  widget: defaultWidgetConfig,
})(CommonButton);
